import { ChevronLeftIcon } from '@heroicons/react/20/solid';
import { navigate } from 'vike/client/router';

import { useIsClient } from '@/renderer/utils/hooks/useIsClient';

/**
 * Top-left "Back" affordance shown only inside the native app (the web has
 * browser chrome for this). Goes back in history, or to the landing if there's
 * nowhere to go back to. Pinned to the viewport (fixed) so it stays put when the
 * keyboard scrolls the page under it.
 */
export default function AppBackButton() {
  const isClient = useIsClient();
  const isNative =
    isClient &&
    !!(window as unknown as { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor
      ?.isNativePlatform?.();

  if (!isNative) return null;

  return (
    <button
      type="button"
      aria-label="Back"
      onClick={() => {
        if (typeof window !== 'undefined' && window.history.length > 1) history.back();
        else navigate('/');
      }}
      className="fixed left-2 top-[max(1rem,env(safe-area-inset-top))] z-50 inline-flex items-center gap-0.5 rounded-lg bg-white/80 px-2 py-1.5 text-sm font-medium text-zinc-600 backdrop-blur transition hover:bg-zinc-500/10 dark:bg-zinc-950/80 dark:text-zinc-300"
    >
      <ChevronLeftIcon className="size-5" />
      Back
    </button>
  );
}
